    import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import styles from "./Styles.module.css";
import OrderFilters from "../../Common/Filters/OrderFilters.jsx";
import { Button } from "primereact/button";
import PaginatorCom from "../../Paginator/PaginatorCom.jsx";
import { useParams } from "react-router";

export default function   BasicTable({
  columns,
  data,
  paginatorData,
  SearchBy,
  handleSearch,
  handleFilter,
  handleClearFilter,
  filters,
  WeekRange,
  MonthRange,
  canlenderFilter,
  handleRowClick,
  onPaginatorClick,
  selectedData,
  handleCellClick,
  button_name,
  handleButton,
}) {
  const [selected, setSelectedData] = useState(selectedData);
  const [metaKey, setMetaKey] = useState(false);
  // const handleFilter = (name, value) => {
  //   console.log("name", name);
  //   console.log("value", value);
  // };
  console.log("data:", data);

  const onRowClick = (e) => {
    setSelectedData(e.data);
    handleRowClick && handleRowClick(e.data);
    console.log("Row clicked:", selected    );
  };

  const isSelectable = (data) => true;

  const isRowSelectable = (event) =>
    event.data ? isSelectable(event.data) : true;

  const rowClassName = (data) => (isSelectable(data) ? "" : "p-disabled");
  // console.log("rowClassName",rowClassName);

  // console.log("selectedData",selectedData);
  // console.log(data);
  // console.log(columns);

  return (
    <div>
      <div className={styles.card}>
        <div className="filter">
          <OrderFilters
            filters={filters ? filters : []}
            SearchBy={SearchBy?.options.length ? SearchBy : { options: [] }}
            WeekRange={WeekRange ? WeekRange : false}
            MonthRange={MonthRange ? MonthRange : false}
            canlenderFilter={canlenderFilter}
            handleFilter={(name, value) =>
              handleFilter && handleFilter(name, value)
            }
            handleClearFilter={() => handleClearFilter && handleClearFilter()}
            handleSearch={handleSearch ? handleSearch : null}
            actionButton={
              button_name &&
              handleButton && {
                button_name: button_name,
                handleButton: handleButton,
              }
            }
          />
        </div>
        <DataTable
          value={data}
          onRowClick={onRowClick}
          selectionMode="single"
          selection={selected}
          metaKeySelection={metaKey}
          onSelectionChange={(e) => setSelectedData(e.value)}
          dataKey="_id"
          isDataSelectable={isRowSelectable}
          rowClassName={rowClassName}
          selected={selected}
        >
          {columns.map((col, i) => (
            <Column
              key={col.field}
              field={col.field}
              header={col.header}
              body={(rowData) =>
                col.accessor
                  ? col.accessor(rowData, handleCellClick)
                  : renderBody(rowData[col.field], handleCellClick)
              }
              style={{color:'var(--dark-color3)'}}
            />
          ))}
        </DataTable>
        <PaginatorCom
          paginatorData={paginatorData}
          onPaginatorClick={onPaginatorClick}
        />
      </div>
    </div>
  );
}

const renderBody = (data, handleCellClick) => {
  // console.log("data",data);

  return (
    <div onClick={() => handleCellClick && handleCellClick(data)}>{data}</div>
  );
};
